import * as React from "react";
import { forwardRef } from "react";
const SvgIconCheck = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 7L10 17L5 12", stroke: "black", strokeWidth: 1.7, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgIconCheck);
export default ForwardRef;
